import { AccommodationProduct } from "../model";
import { getLocalApi } from "./localApi";
import apiConfig from "app/api/apiConfig.json";
import { readIsUsedInActivePackage } from "./productDtoHelpers";

export async function getAccommodationById(accommodationId: string):Promise<AccommodationProduct|void> {
    const localApi = await getLocalApi();

    return await localApi.fetchSingle(apiConfig.accommodation_get_by_id.replace("{accommodationId}", accommodationId),
    mapAccommodationProduct,
    "Failed to fetch accommodation product by Id");
}

function mapAccommodationProduct(accommodationProduct: any): AccommodationProduct {
    const unitTypeIdRaw =
      accommodationProduct.unitTypeId ??
      accommodationProduct.unitType?.id ??
      accommodationProduct.UnitTypeId;
    const unitTypeId =
      unitTypeIdRaw != null && String(unitTypeIdRaw).trim() !== "" && Number(unitTypeIdRaw) > 0
        ? Number(unitTypeIdRaw)
        : undefined;
    const unitTypeText =
      accommodationProduct.unitTypeText ??
      accommodationProduct.unitTypeName ??
      accommodationProduct.unitType?.name ??
      accommodationProduct.UnitTypeName ??
      undefined;
    return {
        id: accommodationProduct.productId,
        name: accommodationProduct.productName,
        type:accommodationProduct.type,
        typeId:accommodationProduct.typeId,
        minStay:accommodationProduct.minimumStay,
        minAge:accommodationProduct.minimumAge,
        maxAge: accommodationProduct.maximumAge ?? null,
        isCommitted: accommodationProduct.isCommitted,
        isNonCommitted:accommodationProduct.isNonCommitted,
        division:0,
        divisionText:"",
        entityUpdate: accommodationProduct.entityUpdate,
        productCategoryId: accommodationProduct.productCategoryId,
        accountCategoryId: accommodationProduct.accountCategoryId,
        excludedBookingSystemIds: [],
        decommissionDate: accommodationProduct.decommissionDate ?? accommodationProduct.offeringClosureDate,
        active: accommodationProduct.active ?? !accommodationProduct.decommissionDate,
        unitTypeId,
        unitTypeText,
        isUsedInActivePackage: readIsUsedInActivePackage(accommodationProduct),
    }
}